
import {Component, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import 'vue-select/dist/vue-select.css';

@Component({
  name: 'global-modal',
  components: ServiceContainer().getComponents(),
})

export default class extends Vue {
  private get getShowModalState(): boolean {
    return this.$store.getters['PreorderIndex/getShowModalState'] || false;
  }

  private get getModalSettings(): object {
    return this.$store.getters['PreorderIndex/getModalSettings'] || {id: 0};
  }

  private closePopup(id = 0): void {
    if (id === 2) {
      this.$store.dispatch('PreorderIndex/executeModalAction', this.getModalSettings['id']);
      this.$eventBus.$emit('modal-action', this.getModalSettings['id'], 2);
      return;
    }

    this.$store.dispatch('PreorderIndex/showModal', false);

    setTimeout(() => {
      this.$store.dispatch('PreorderIndex/setModalSettings', {
        id: 0,
        title: '',
        content: ''
      });
    }, 300);
  }

  private executeModalAction(): void {
    this.$store.dispatch('PreorderIndex/executeModalAction', this.getModalSettings['id']);
    this.$store.dispatch('PreorderIndex/showModal', false);
    this.$eventBus.$emit('modal-action', this.getModalSettings['id'], 1);
  }
}
